import React from 'react';
import styled from 'styled-components';

// import ArrowLeftDetailIcon from '../../../../Icons/ArrowLeftDetailIcon';
// import ArrowRightDetailIcon from '../../../../Icons/ArrowRightDetailIcon';

import WhiteArrowLeft from '../../../../Icons/Partner/WhiteArrowLeft';
import WhiteArrowRight from '../../../../Icons/Partner/WhiteArrowRight';

import useCarousel from '../../../../../shared/hooks/useCarousel';

interface IMainGalleryList {
  alternateText: string;
  data: Array<object>;
  onGalleryClick: Function;
  dimension: string;
  offerPersuasion?: {
      text ?: string
  }
}

const MainGallery = ({alternateText, data, onGalleryClick, dimension, offerPersuasion}: IMainGalleryList) => {
  const {dataList, increment, decrement, isLeftCursorActive, isRightCursorActive} = useCarousel(
    data,
    1,
  );
  return (
    <>
      <DetailBigGallery>
      {offerPersuasion.text ? <UnstyledDiv>{offerPersuasion.text}</UnstyledDiv> : null}
        {dataList.map((item, i) =>
          <GalleryBigImg src={item.b} alt={alternateText} key={item.b || i} itemProp="image" onClick={() => onGalleryClick('captivate')} />
        )}
        <GalleryInfoOverlay>
          <OverlayText>Hotel Interior & Lobby</OverlayText>
        </GalleryInfoOverlay>
        {(isLeftCursorActive &&
          <LeftIconWrap  onClick={decrement}><WhiteArrowLeft /></LeftIconWrap>
        ) || null}
        {(isRightCursorActive &&
          <RightIconWrap onClick={increment}>
            <WhiteArrowRight />
          </RightIconWrap>
        ) || null}
      </DetailBigGallery>
      {/* {dimension === 'normalWidth' ? (
        <MainGalleryOuterWrapDiv>
          {dataList.map((item, i) => (
            <HotelMainGalleryImage
              src={item.b}
              alt={alternateText}
              key={item.b || i}
              itemProp="image"
              onClick={() => onGalleryClick('captivate')}
            />
          ))}

          {(isLeftCursorActive && <LeftArrowGallery onClick={decrement}></LeftArrowGallery>) || ''}
          {(isRightCursorActive && <RightArrowGallery onClick={increment}></RightArrowGallery>) ||
            ''}
        </MainGalleryOuterWrapDiv>
      ) : (
        ''
      )}
      {dimension === 'fullWidth' ? (
        <MainGalleryFullWidthDiv>
          {dataList.map((item, i) => (
            <HotelMainGalleryImage
              src={item.b}
              alt={alternateText}
              key={item.b || i}
              onClick={() => onGalleryClick('captivate')}
            />
          ))}

          {(isLeftCursorActive && <LeftArrowGallery onClick={decrement}></LeftArrowGallery>) || ''}
          {(isRightCursorActive && <RightArrowGallery onClick={increment}></RightArrowGallery>) ||
            ''}
        </MainGalleryFullWidthDiv>
      ) : (
        ''
      )} */}
    </>
  );
};

export default MainGallery;

export const DetailBigGallery = styled.div(
  props => `
      width: 51.5rem;
      height: 35rem;
      display: flex;
      position: relative;
  `
);

export const GalleryBigImg = styled.img(
  props => `
      width: 100%;
      height:35rem;
      // object-fit: contain;
  `
);

export const UnstyledDiv = styled.div(
    props => `
    position:absolute;
    left:-1.3%;
    top:-3%;
    border-radius:2px;
    display: inline-block;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(75deg, #339933, #33cc33);
    height : 20px;
    text-align: center;
    line-height:1.6;
    font-weight:900;
    color:white;
    padding : 0px 3px;
    &:after {
        content: "";
        border-top: 0.5rem solid rgb(24, 161, 96);
        border-left: 0.7rem solid transparent;
        position: absolute;
        left: 0px;
        top: 1.8rem;
    }
  `
  );

export const GalleryInfoOverlay = styled.div(
  props => `
      width:100%;
      display: flex;
      // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
      background: #000000;
      height: 5rem;
      padding: ${props.theme.spacing.large.l20};
      position: absolute;
      bottom: 0;
      left:0;
      justify-content: center;
      align-items: center;
      // align-items: flex-end;
  `
);

export const OverlayText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      text-transform: ${props.theme.font.textTransform.upper};
  `
);

export const LeftIconWrap = styled.div(
  props => `
      position: absolute;
      top: 50%;
      left: 1rem;
      transform: translateY(-50%);
  `
);

export const RightIconWrap = styled.div(
  props => `
      position: absolute;
      top: 50%;
      right: 1rem;
      transform: translateY(-50%);
  `
);

// const MainGalleryOuterWrapDiv = styled.div(
//   props => `
//   display: flex;
//   flex-wrap:wrap;
//   flex-direction: column;
//   position:relative;
//   width:38.6rem;
//   cursor: pointer;

// `,
// );

// const ViewAllBtn = styled.button(
//   props => `
//   position:absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   font-size: ${props.theme.font.large.font22};
//   font-weight:bold;
//   border: .3rem solid ${props.theme.colors.white.base};
//   border-radius: ${props.theme.misc.borderRadius.custom(9)};
//   color: ${props.theme.colors.white.base};
//   padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
//   width: 22rem;
//   text-align: center;
//   z-index: ${props.theme.misc.zIndex.xxsmall};
//   font-family: ${props.theme.font.fontFamily};
//   background: transparent;
//   cursor:pointer;
// `,
// );

// const ViewAllImageswrap = styled.div(
//   props => `


// `,
// );

// const OverlayImageWrapDiv = styled.div(
//   props => `
//   display: flex;
//   position: absolute;
//   bottom: ${props.theme.spacing.small.s6};
//   left: 0;
//   top:0
//   width: 38.6rem;
//   height: 32rem;
//   -webkit-box-align: center;
//   align-items: center;
//   -webkit-box-pack: center;
//   justify-content: center;
//   background-color: ${props.theme.colors.shadow.dark};
//   cursor: pointer;
//   border-radius: ${props.theme.misc.borderRadius.xxxlarge};
// `,
// );

// const MainGalleryFullWidthDiv = styled.div(
//   props => `
//   display: flex;
//   flex-wrap:wrap;
//   flex-direction: column;
//   position:relative;
//   width:58rem;
//   cursor: pointer;
// `,
// );

// const HotelMainGalleryImage = styled.img(
//   props => `
//     display: flex;
//     border-radius: ${props.theme.misc.borderRadius.xxxlarge};
//     width: 100%;
//     height: 32rem;
//     object-fit: cover;
// `,
// );

// const LeftArrowGallery = styled(ArrowLeftDetailIcon)(
//   props => `
//       width:3.5rem;
//       height:3.5rem;
//       fill: ${props.theme.colors.black.base};
//       position :absolute;
//       top:15rem;
//       left:1.4rem;
//       background:${props.theme.colors.white.base};
//       border-radius:50%;
//       padding:1rem;
//       z-index: ${props.theme.misc.zIndex.xsmall};
//   `,
// );

// const RightArrowGallery = styled(ArrowRightDetailIcon)(
//   props => `
//       width:3.5rem;
//       height:3.5rem;
//       fill: ${props.theme.colors.black.base};
//       position :absolute;
//       top:15rem;
//       right:1.4rem;
//       background:${props.theme.colors.white.base};
//       border-radius:50%;
//       padding:1rem;
//       z-index: ${props.theme.misc.zIndex.xsmall};
//   `,
// );
